.card {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-3);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-default);
}

.sentence {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

.caption,
.helper {
  margin: 0;
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-secondary);
}

.controls {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
}

.state {
  font-weight: 600;
}

.tagInput {
  min-width: 6rem;
  padding: var(--tuna-spacing-1);
}

@media (max-width: 599.95px) {
  .sentence {
    flex-direction: column;
    align-items: flex-start;
  }
}
